export interface SalesOrderMultiProductCreate {
  id: string;
  salesOrderHeaderId: string;
  salesOrderLineId: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  productTypeDescription: string;
  sequence: number;
  quantity: number;
  unitOfMeasure: string;
  price: number;
  deliveryDate: Date;
  selected: boolean;
  sellingCompany: string;
}
